import "react";
import r from "prop-types";
import { palette as e } from "@leafygreen-ui/palette";
import { css as n, cx as o } from "@leafygreen-ui/emotion";
import { jsx as t } from "@emotion/react";

function l(r, e, n) {
  return e in r ? Object.defineProperty(r, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : r[e] = n, r;
}

function a() {
  return a = Object.assign || function (r) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];

      for (var o in n) {
        Object.prototype.hasOwnProperty.call(n, o) && (r[o] = n[o]);
      }
    }

    return r;
  }, a.apply(this, arguments);
}

function i(r, e) {
  if (null == r) return {};

  var n,
      o,
      t = function (r, e) {
    if (null == r) return {};
    var n,
        o,
        t = {},
        l = Object.keys(r);

    for (o = 0; o < l.length; o++) {
      n = l[o], e.indexOf(n) >= 0 || (t[n] = r[n]);
    }

    return t;
  }(r, e);

  if (Object.getOwnPropertySymbols) {
    var l = Object.getOwnPropertySymbols(r);

    for (o = 0; o < l.length; o++) {
      n = l[o], e.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(r, n) && (t[n] = r[n]);
    }
  }

  return t;
}

function c(r, e) {
  return e || (e = r.slice(0)), Object.freeze(Object.defineProperties(r, {
    raw: {
      value: Object.freeze(e)
    }
  }));
}

var d,
    g,
    u,
    p,
    f,
    s,
    b,
    y,
    h = ["children", "variant", "className"],
    m = {
  DarkGray: "darkgray",
  LightGray: "lightgray",
  Red: "red",
  Yellow: "yellow",
  Blue: "blue",
  Green: "green"
},
    v = n(d || (d = c(["\n  font-family: Euclid Circular A, ‘Helvetica Neue’, Helvetica, Arial, sans-serif; // TODO: Refresh – remove when fonts are updated\n  display: inline-flex;\n  align-items: center;\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 16px;\n  border-radius: 5px;\n  height: 18px;\n  padding-left: 6px;\n  padding-right: 6px;\n  text-transform: uppercase;\n  border: 1px solid;\n  letter-spacing: 1px;\n"]))),
    O = (l(y = {}, m.LightGray, n(g || (g = c(["\n    background-color: ", ";\n    border-color: ", ";\n    color: ", ";\n  "])), e.gray.light3, e.gray.light2, e.gray.dark1)), l(y, m.DarkGray, n(u || (u = c(["\n    background-color: ", ";\n    border-color: ", ";\n    color: ", ";\n  "])), e.gray.dark2, e.gray.dark3, e.white)), l(y, m.Red, n(p || (p = c(["\n    background-color: ", ";\n    border-color: ", ";\n    color: ", ";\n  "])), e.red.light3, e.red.light2, e.red.dark2)), l(y, m.Yellow, n(f || (f = c(["\n    background-color: ", ";\n    border-color: ", ";\n    color: ", ";\n  "])), e.yellow.light3, e.yellow.light2, e.yellow.dark2)), l(y, m.Blue, n(s || (s = c(["\n    background-color: ", ";\n    border-color: ", ";\n    color: ", ";\n  "])), e.blue.light3, e.blue.light2, e.blue.dark1)), l(y, m.Green, n(b || (b = c(["\n    background-color: ", ";\n    border-color: ", ";\n    color: ", ";\n  "])), e.green.light3, e.green.light2, e.green.dark2)), y);

function k(r) {
  var e = r.children,
      n = r.variant,
      l = void 0 === n ? m.LightGray : n,
      c = r.className,
      d = i(r, h);
  return t("div", a({}, d, {
    className: o(v, O[l], c)
  }), e);
}

k.displayName = "Badge", k.propTypes = {
  className: r.string,
  children: r.node,
  variant: r.oneOf(Object.values(m))
};
export { m as Variant, k as default };